import { Initials, ProgressLine, Tag, attTone } from "@/components/kit";
import { useStore } from "@/store/AppStore";
import { ranking } from "@/lib/selectors";
import { taskStats, visibleTasks } from "@/lib/tasks";

export function TeamPerformance({ companyId, onSelect, selected }) {
  const { state } = useStore();
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4" data-testid="team-performance">
      {ranking(state, companyId).map((m) => {
        const st = taskStats(visibleTasks(state, m));
        const Tagname = onSelect ? "button" : "div";
        return (
          <Tagname key={m.id} onClick={onSelect && (() => onSelect(m.id))} data-testid={`team-member-${m.id}`} className={`rounded-xl border bg-white p-5 text-left transition-[transform,box-shadow,border-color] duration-200 ${onSelect ? "hover:-translate-y-0.5 hover:shadow-md" : ""} ${selected === m.id ? "border-gold ring-1 ring-gold" : "border-neutral-200"}`}>
            <div className="flex items-center gap-3">
              <Initials name={m.name} className="h-11 w-11 text-sm" />
              <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold">{m.name}</p><p className="text-xs text-neutral-500">{m.role} · {m.position}º no ranking</p></div>
            </div>
            <div className="mt-4 flex items-center justify-between text-xs">
              <span className="text-neutral-500" data-testid={`member-tasks-${m.id}`}>Tarefas <span className="font-semibold text-neutral-900">{st.done}/{st.total}</span> ({st.pct}%)</span>
              {st.overdue > 0 ? <Tag tone="red" testId={`member-overdue-${m.id}`}>{st.overdue} atrasada(s)</Tag> : <Tag tone="green">Em dia</Tag>}
            </div>
            <div className="mt-2"><ProgressLine value={st.pct} /></div>
            <div className="mt-3 flex items-center justify-between text-xs text-neutral-500"><span>Meta de vendas</span><Tag tone={attTone(m.att)}>{m.att}%</Tag></div>
            {st.awaiting > 0 && <p className="mt-2 text-xs font-medium text-gold-dark">{st.awaiting} aguardando aprovação</p>}
          </Tagname>
        );
      })}
    </div>
  );
}
